import { render, staticRenderFns } from "./ListaRelatoriosEspecificos.vue?vue&type=template&id=1199bf08"
import script from "./ListaRelatoriosEspecificos.vue?vue&type=script&lang=js"
export * from "./ListaRelatoriosEspecificos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports